import { render, staticRenderFns } from "./ActiveFiltersBar.vue?vue&type=template&id=388a3879"
import script from "./ActiveFiltersBar.vue?vue&type=script&lang=js"
export * from "./ActiveFiltersBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports